import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    header:
      'flex w-full items-center justify-between max-lg:h-16 max-lg:cursor-pointer max-lg:bg-[#093648] max-lg:px-5',
    chevron: 'hidden rotate-90 transition-transform max-lg:block',
    content: 'lg:!max-h-max'
  },
  variants: {},
  defaultVariants: {}
});
